import _ from 'lodash'
// @ts-ignore
import DOMPurify from 'dompurify';
import { onMounted, ref, computed, nextTick } from 'vue';
import { useResizeObserver } from '@vueuse/core';
import { container } from '@eureka/services';
import { getCurrentLanguage } from '@eureka/language-tool';

const BICHART_DIMENSIONS = [
    {
        key: 'ANCS',
        title: {
            cn: '所有者',
            en: 'Owner',
            tw: '所有者',
            jp: 'オーナー',
        },
    },
    {
        key: 'BENEFIT_PHRASE',
        title: {
            cn: '技术效果',
            en: 'Technical Advancement',
            tw: '技術效果',
            jp: '技術効果語',
        },
    },
    {
        key: 'BENEFIT_PT',
        title: {
            cn: '技术效果',
            en: 'Technical Output',
            tw: '技術效果',
            jp: '技術的な成果',
        },
    },
    {
        key: 'MATERIAL',
        title: {
            cn: '特征属性',
            en: 'Property',
            tw: '特徴抽出',
            jp: '特徵屬性',
        },
    },
    {
        key: 'ADC',
        title: {
            cn: '应用领域分类',
            en: 'Application Domain',
            tw: '應用領域分類',
            jp: '応用分野分類',
        },
    },
    {
        key: 'ADC_A',
        title: {
            cn: '应用领域1级',
            en: 'Application domain 1st level',
            tw: '應用領域1级',
            jp: '応用分野の第1階層',
        },
    },
    {
        key: 'ADC_B',
        title: {
            cn: '应用领域2级',
            en: 'Application domain 2nd level',
            tw: '應用領域2级',
            jp: '応用分野の第2階層',
        },
    },
    {
        key: 'ADC_C',
        title: {
            cn: '应用领域3级',
            en: 'Application domain 3rd level',
            tw: '應用領域3级',
            jp: '応用分野の第3階層',
        },
    },
    {
        key: 'ADC_D',
        title: {
            cn: '应用领域4级',
            en: 'Application domain 4th level',
            tw: '應用領域4级',
            jp: '応用分野の第4階層',
        },
    },
    {
        key: 'TTC',
        title: {
            cn: '技术主题分类',
            en: 'Technology Topic',
            tw: '技術主題分類',
            jp: '技術トピック分類',
        },
    },
    {
        key: 'TTC_CLUSTER_LA',
        title: {
            cn: '技术主题1级',
            en: 'Technology topic 1st level',
            tw: '技術主題1級',
            jp: 'トピック・ランク1',
        },
    },
    {
        key: 'TTC_CLUSTER_LB',
        title: {
            cn: '技术主题2级',
            en: 'Technology topic 2nd level',
            tw: '技術主題2級',
            jp: 'トピック・ランク2',
        },
    },
    {
        key: 'TTC_CLUSTER_LC',
        title: {
            cn: '技术主题3级',
            en: 'Technology topic 3rd level',
            tw: '技術主題3級',
            jp: 'トピック・ランク3',
        },
    },
    {
        key: 'TECH',
        title: {
            cn: '技术领域词',
            en: 'Technology Field Word',
            tw: '科技領域詞',
            jp: '技術分野の用語',
        },
    },
    {
        key: 'TECH_DOMAIN_ONE_ID',
        title: {
            cn: '技术领域1级',
            en: 'Technology field word 1st level',
            tw: '科技領域1級',
            jp: '技術分野1級',
        },
    },
    {
        key: 'TECH_DOMAIN_SEC_ID',
        title: {
            cn: '技术领域2级',
            en: 'Technology field word 2nd level',
            tw: '科技領域2級',
            jp: '技術分野2級',
        },
    },
    {
        key: 'COUNTRY',
        title: {
            cn: '受理局',
            en: 'Authority',
            tw: '受理局',
            jp: '受理官庁',
        },
    },
    {
        key: 'PATENT_TYPE',
        title: {
            cn: '专利类型',
            en: 'Patent Type',
            tw: '專利類型',
            jp: '特許タイプ',
        },
    },
    {
        key: 'SIMPLE_LEGAL_STATUS',
        title: {
            cn: '专利权状态',
            en: 'Patent Status',
            tw: '專利權狀態',
            jp: '特許権状態',
        },
    },
    {
        key: 'APD_Y',
        title: {
            cn: '申请年',
            en: 'Application Year',
            tw: '申請年',
            jp: '出願年',
        },
    },
    {
        key: 'IN_FACET',
        title: {
            cn: '发明人',
            en: 'Inventor',
            tw: '發明人',
            jp: '発明者',
        },
    },
    {
        key: 'PROBLEM_PHRASE_ID',
        title: {
            cn: '技术问题',
            en: 'Technical Problem Phrases',
            jp: '技術的な問題句',
            tw: '技術問題',
        },
    },
    {
        key: 'BENEFIT_THEME',
        title: {
            cn: '主题',
            en: 'Topic Word',
            jp: '主題詞',
            tw: '主題',
        },
    },
    {
        key: 'TECH_DOMAIN_ONE_ID',
        title: {
            cn: '技术领域1级',
            en: 'Technology Field Word 1st Level',
            jp: '技術分野1級',
            tw: '技術領域1級',
        },
    },
    {
        key: 'EUREKA_REFINE_KEYWORD',
        title: {
            cn: '关键词',
            en: 'Keyword',
            tw: '關鍵詞',
            jp: 'キーワード',
        },
    }
]

export interface BIChartProps {
    configTaskFunc:() => Promise<any>,
    dataTaskFunc: () => Promise<any>,
    getChartStr: (data: { img: string, data: unknown[][] }) => void,
    colorFunc?: (data: any[]) => any[],
    chartKey: string,
    isLoading: boolean,
}

export function useBIChart(props: BIChartProps) {
    /* data */
    const id = ref<string>('id');
    const containerClass = ref<string>(`bi-chart-${props.chartKey}__container`);
    const visualCurr = ref<any>(undefined);
    const rootElement = ref(null);

    /* computed */
    const fieldConf = computed(() => {
        return _.map(BICHART_DIMENSIONS, cfg => ({
            code: cfg.key,
            dataType: 'TEXT',
            name: cfg.title,
            description: cfg.title,
        }));
    });
    const locale = computed(() => {
        return getCurrentLanguage();
    });

    /**
     * 用于处理bi不支持的字段
     */
    function axisFn(data: any) {
        const { datasource, datasourceDimensionConstructor } = data;
        const getDimensionsByCodes = datasource.getDimensionsByCodes;
        datasource.getDimensionsByCodes = async function(codes: string[], keys?: string[]) {
            // APD_Y在bi翻译为申请日，这边需要申请年。标当前申请人需要改成所有者
            const overwriteFields = ['APD_Y', 'ANCS'];
            // bi支持的字段内容
            const basicFieldConf = await getDimensionsByCodes.bind(datasource)(codes, keys);
            // bi支持的字段（排除不需要的）内容
            const usedBasicFieldConf = _.reject(basicFieldConf, item => _.includes(overwriteFields, item.code));
            // bi不支持的字段名
            const externalCodes = _.difference(codes, _.map(usedBasicFieldConf, 'code'));
            // bi不支持的字段内容
            const externalFields = await Promise.all(externalCodes.map(code => {
                // @ts-ignore
                return datasourceDimensionConstructor.read(_.find(fieldConf.value, { code }), locale.value)
            }));
            return [...usedBasicFieldConf, ...externalFields];
        };
    }

    function getConfig() {
        return props.configTaskFunc();
    }

    function getData() {
        return props.dataTaskFunc().then(data => {
            _.forEach(data?.extra, (v, k) => {
                const items = _.get(data.extra, k);
                _.forEach(items, item => {
                    if (item.label) {
                        item.label = DOMPurify.sanitize(item.label, { ALLOWED_TAGS: [] });
                    }
                })
            })
            return {
                TARGET_PATENT_COUNT: data,
                NEW_CHART: true,
            }
        });
    }

    function handleResize() {
        visualCurr.value?.resize?.();
    }

    async function getBase64Str() {
        try {
            const str = await visualCurr.value?.getDataURL({
                type: 'png',
                pixelRatio: 2,
                backgroundColor: '#fff',
                svgSelector: '.analysis-bi-chart .world-cloud-wrapper',
            })
            return str;
        } catch (e) {
            console.log('get base64 error:', e);
            return '';
        }
    }

    onMounted(async() => {
        const [moduleVisual, moduleCreate, { default: matrixContainer }] = await Promise.all([
            // @ts-ignore
            import('MatrixCore/Visuals'),
            // @ts-ignore
            import('MatrixCore/createVisualWithoutChartId'),
            // @ts-ignore
            import('MatrixCore/container')
        ]);

        const { Visuals } = moduleVisual.default;
        const createVisualWithoutChartId = moduleCreate.default;

        const {
            visual,
            loadDataset,
            analysisSetting,
            /* datasource, */
        } = await createVisualWithoutChartId(id.value, locale.value, {}, {
            async loadVisual(visualId:string) {
                // @ts-ignore
                const targetVisualChart = await import('MatrixCore/ChartInstances').then(res => {
                    console.log('targetVisualChart', res, visualId)
                    return res.default[visualId]
                });
                Visuals.registerVisual(targetVisualChart);
                const ChartClass = await Visuals.install(visualId);
                return ChartClass;
            },
            patch() {
                matrixContainer.BiHttp.httpClient = container.RnDHttp.httpClient;
            },
        }, getData, getConfig, axisFn, 'Eureka');
        const dataset = await loadDataset('Eureka');
        visual.isChangeWithContainer = true;
        const postUpdate = visual.postUpdate;

        visual.renderEmpty = visual.renderError = (el: HTMLElement) => {
            visual.dispose();
            const noData = document.querySelector('.analysis-bi-chart .chart-no-data')?.cloneNode(true);
            if (noData) {
                // @ts-ignore
                noData.style.display = 'flex';
                el.appendChild(noData);
            }
        };
        visual.clickable((data: any) => {
            const dimensions = _.get(visual, '_dataset.0.result.TARGET_PATENT_COUNT.dimensions').slice(0, -1)

            let dimensionKeys = dimensions;
            if (_.isObject(dimensions[0])) {
                dimensionKeys = _.flatten(_.map(dimensions, dimension => _.keys(dimension)));
            }
            const dimensionValues = _.zipObject(dimensionKeys, _.get(visual, '_dataset.0.cutaways'));
            _.reject(_.zipWith(dimensionKeys, [data.firstCode, data.secondCode, data.thirdCode], (k, v) => ({
                field: k,
                value: v,
                // @ts-ignore
                alias: _.chain(dimensionValues).get(k).find({ code: v }).get('name').value(),
            })), { field: undefined })

            // @ts-ignore
            // this.$emit('click', {
            //     // @ts-ignore
            //     chartKey: this.chartKey,
            //     value: kvs,
            // });
        });
        visual.postUpdate = (...data: any) => {
            postUpdate.apply(visual, data);
        };
        visualCurr.value = visual;
        props.isLoading = false;
        await nextTick();
        if (rootElement.value) {
            useResizeObserver(rootElement, handleResize);
        }
        if (_.isFunction(props.colorFunc)) {
            visual.style.colors.colors = props.colorFunc(visual.style.colors.colors);
        }
        try {
            // @ts-ignore
            visual.trueUpdate(document.querySelector(`.${containerClass.value}`), dataset, visual.displayOptions, visual.style, analysisSetting);
            await nextTick();
            setTimeout(async() => {
                const imgStr = await getBase64Str();
                props.getChartStr({ img: imgStr, data: _.get(dataset, '[0].cutaways', []) });
            }, 1000);
        } catch (e) {
            window.console.log(e)
        }
    })

    return {
        rootElement,
        containerClass,
        handleResize,
        getBase64Str,
    }
}
